import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Chip
} from "@mui/material";
import { WorkerTransaction } from "../interfaces/Worker";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PaymentIcon from '@mui/icons-material/Payment';

interface WorkerHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  workerName?: string;
  history?: WorkerTransaction[];
}

export default function WorkerHistoryDialog({ open, onClose, workerName, history = [] }: WorkerHistoryDialogProps) {
  
  // Sort history newest first
  const sortedHistory = [...history].sort((a, b) => b.date - a.date);

  const formatDate = (ms: number) => {
    return new Date(ms).toLocaleString("es-CO", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight={700}>Historial de Movimientos</Typography>
        <Typography variant="body2" color="text.secondary">{workerName}</Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {sortedHistory.length === 0 ? (
          <Box p={3} textAlign="center">
            <Typography color="text.secondary">No hay transacciones registradas.</Typography>
          </Box>
        ) : (
          <List sx={{ width: '100%', bgcolor: 'background.paper', p: 0 }}>
            {sortedHistory.map((tx, idx) => (
              <React.Fragment key={tx.id}>
                <ListItem alignItems="flex-start" sx={{ px: 3, py: 2 }}>
                  <ListItemIcon>
                    {tx.type === "compra" ? (
                      <ShoppingCartIcon color="error" />
                    ) : (
                      <PaymentIcon color="success" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle2" fontWeight={700}>
                          {tx.type === "compra" ? "Compra (Crédito)" : "Abono"}
                        </Typography>
                        <Typography 
                          variant="subtitle2" 
                          fontWeight={800} 
                          color={tx.type === "compra" ? "error.main" : "success.main"}
                        >
                          {tx.type === "compra" ? "+" : "-"}${tx.amount.toLocaleString()}
                        </Typography>
                      </Box>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {tx.detail}
                        </Typography>
                        {tx.paymentMethod && (
                           <Chip label={tx.paymentMethod.toUpperCase()} size="small" variant="outlined" sx={{ ml: 1, height: 20, fontSize: "0.65rem" }} />
                        )}
                        <br />
                        {formatDate(tx.date)}
                      </React.Fragment>
                    }
                  />
                </ListItem>
                {idx < sortedHistory.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="primary">Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
